import { setEmployerActiveFilter } from 'store/employer-active-filter/actions'
import { VisibilityFilters } from 'actions'
import { connect } from 'react-redux'
import ManageEmployers from './ManageEmployers'

const mapStateToProps = state => ({
  showActiveOnly: state.employerActiveFilter === VisibilityFilters.SHOW_ACTIVE
})

const mapDispatchToProps = dispatch => ({
  setEmployerActiveFilter: (filter) => {
    dispatch(setEmployerActiveFilter(filter))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageEmployers)



// WEBPACK FOOTER //
// ./src/components/ManageEmployers/index.js